import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";

import { useDataState } from "../../../hooks/useDataState";

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

import { trackPromise } from 'react-promise-tracker';

import http from "../../../shared/http-common";

import MaterialTable, { MTableToolbar } from "@material-table/core";
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';


import LoadingIndicator from "../../../shared/LoadingIndicator";
import {List, ListItem} from "@mui/material";
import DataObjectsEdit from "./DataObjectEdit";
import DataobjectService from "../../../services/DataobjectService";
import DataComponentEdit from "./DataComponentEdit";
import UploadDialog from "./UploadDialog";

import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";
import ObjecttypeService from "../../../services/ObjecttypeService";

import UserService from "../../../services/UserService";
import {buildRealmPath} from "../../../shared/routing";

import { header } from'../../../shared/headerStyle';
import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router";
import { useSharedListStyles } from "../../../shared/useSharedListStyles";


const GetObjectSubData = async (guid, objecttype, realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("guid", guid);

        return await http.post(`/` + objecttype + `/getAllObjects`, formData,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    } catch (e) {
        console.error(e);
    }

}

const GetObjectData = async (realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        return await http.post(`/administrativeobject/economicunit/list`, formData,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    } catch (e) {
        console.error(e);
    }
};

const GetObjectDataByType = async (obejcttype, type, realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        return await http.post(`/` +obejcttype+`/` + type + `/list`, formData,{
            headers: {
                "Content-Type": "application/json"
            }
        });
    } catch (e) {
        console.error(e);
    }
};

// Objekttyp-Auswahl -> welcher Objekttyp/Typ geladen wird und wie die Tabelle betitelt/gefiltert wird.
const OBJECT_TYPE_CONFIG = {
    site: { objecttype: 'realestateobject', type: 'site', title: 'Liegenschaften' },
    structure: { objecttype: 'realestateobject', type: 'structure', title: 'Bauwerke' },
    building: { objecttype: 'realestateobject', type: 'building', title: 'Gebäude' },
    room: { objecttype: 'realestateobject', type: 'room', title: 'Räume' },
    storey: { objecttype: 'realestateobject', type: 'storey', title: 'Etagen' },
    playground: { objecttype: 'realestateobject', type: 'playground', title: 'Spielplätze' },
    wastecollectionpoint: { objecttype: 'realestateobject', type: 'wastecollectionpoint', title: 'Müllstandplatz' },
    economicunit: { objecttype: 'administrativeobject', type: 'economicunit', title: 'Wirtschafteinheiten' },
    apartment: { objecttype: 'administrativeobject', type: 'apartment', title: 'Wohnungen' },
    rentalunit: { objecttype: 'administrativeobject', type: 'rentalunit', title: 'Mieteinheiten' },
    commercialunit: { objecttype: 'administrativeobject', type: 'commercialunit', title: 'Gewerbeeinheiten' },
    parkingspace: { objecttype: 'administrativeobject', type: 'parkingspace', title: 'Stellplatzanlagen' },
    location: { objecttype: 'administrativeobject', type: 'buildingentrance', title: 'Hauseingänge' },
    buildingentrance: { objecttype: 'administrativeobject', type: 'buildingentrance', title: 'Hauseingänge' },
    parcel: { objecttype: 'administrativeobject', type: 'parcel', title: 'Flurstücke' },
    territorialdivision: { objecttype: 'administrativeobject', type: 'territorialdivision', title: 'Gebietsgliederungen' },
    washhouse: { objecttype: 'administrativeobject', type: 'washhouse', title: 'Waschhäuser' },
};
const DEFAULT_OBJECT_TYPE_CONFIG = { objecttype: 'administrativeobject', type: 'economicunit', title: 'Wirtschaftseinheiten' };


function DataobjectsListTable({dataObjects, handleObjecttypeChange, realm, token, setDataObjects}) {
    const data = useDataState();
    const setDataobjectsDialogOpen = data.setDialogOpen;
    const [dataObjectSelected, setDataObjectSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [DataComponentEditDialogOpen, setDataComponentEditDialogOpen] = useState(false);
    const [DataComponentFormDialogOpen, setDataComponentFormDialogOpen] = useState(false);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [filtering, setFiltering] = useState(false);
    const [tableDataId, setTableDataId] = useState(null);

    const tableRef = useRef();

    let navigate = useNavigate();


    const location = useLocation();

    const objectType = location?.state?.objectType;
    useEffect(() => {
        if(objectType) {
            putChangesInMotion(objectType)
        }
    }, [objectType])



    const handleEditClick = async (object) => {
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            const result = await DataobjectService.getAdministrativeObject(token, realm, object.guid);
            setDataObjectSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            const result = await DataobjectService.getRealestateObject(token, realm, object.guid);
            setDataObjectSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        }
    }

    // Aktiviert/Deaktiviert ein Datenobjekt ueber die uebergebenen Service-Aufrufe.
    const changeObjectStatus = async (adminServiceFn, realestateServiceFn, object, event) => {
        event.preventDefault();
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            await adminServiceFn(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            await realestateServiceFn(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        }
    }

    const handleDeactivateClick = (object, event) =>
        changeObjectStatus(DataobjectService.deactivateAdministrativeobject, DataobjectService.deactivateRealestateobject, object, event);

    const handleActivateClick = (object, event) =>
        changeObjectStatus(DataobjectService.activateAdministrativeobject, DataobjectService.activateRealestateobject, object, event);

    const handleComponentClick = (event, rowData) => {
        setDataObjectSelected(rowData);
        setDataComponentEditDialogOpen(true);
    }

    const handleUploadClick = (event, item) => {
        event.preventDefault();
        setDataObjectSelected(item);
        setDataobjectsDialogOpen(false);
        setDataComponentEditDialogOpen(false);
        setUploadDialogOpen(true);
    }

    let bauteilActionRO = {
        icon: 'hardware',
        tooltip: 'Bauteile',
        onClick: (event, rowData) => handleComponentClick(event, rowData),
    }
    let bauteilActionAO = '';

    const options = [
        {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
        {value: 'territorialdivision', text: 'Gebietsgliederung'},
        {value: 'site', text: 'Liegenschaft'},
        {value: 'economicunit', text: 'Wirtschaftseinheit'},
        {value: 'parcel', text: 'Flurstück'},
        {value: 'structure', text: 'Bauwerk'},
        {value: 'building', text: 'Gebäude'},
        {value: 'storey', text: 'Geschoß'},
        {value: 'buildingentrance', text: 'Hauseingang'},
        {value: 'rentalunit', text: 'Mieteinheit'},
        {value: 'commercialunit', text: 'Gewerbeeinheit'},
        {value: 'apartment', text: 'Wohnung'},
        {value: 'room', text: 'Raum'},
        {value: 'playground', text: 'Spielplatz'},
        {value: 'parkingspace', text: 'Stellplatz'},
        {value: 'wastecollectionpoint', text: 'Müllstandplatz'},
    ];

    const [selected, setSelected] = useState(options[0].value);
    const [title, setTitle] = useState('Bitte wählen Sie einen Objekttypen');
    const [fieldType, setFieldType] = useState('administrativeobjectType');
    const [bauteilAction, setBauteilAction] = useState('');

    let hideDeactivatedColumn = true


    const handleChange = (event) => {
        putChangesInMotion(event.target.value);
    }

    const putChangesInMotion = (val) => {
        setSelected(val);
        const config = OBJECT_TYPE_CONFIG[val] || DEFAULT_OBJECT_TYPE_CONFIG;
        const isRealestate = config.objecttype === 'realestateobject';
        setTitle(config.title);
        setFieldType(isRealestate ? 'realestateobjectType' : 'administrativeobjectType');
        setBauteilAction(isRealestate ? bauteilActionRO : bauteilActionAO);

        return handleObjecttypeChange(config.objecttype, config.type);
    };

    const getColumnType = () => {
        return fieldType;
    }


    if(filtering) {
        hideDeactivatedColumn = false;
    }


    const reloadObjects = () => {
        putChangesInMotion(selected)
            .then(() => {
                const theData = tableRef.current?.state?.renderData;
                if (theData instanceof Array) {
                    if (tableDataId !== null) {
                        const _data = [...dataObjects];
                        _data.forEach((item) => {
                            if (item.tableData.showDetailPanel) {
                                item.tableData.showDetailPanel = '';
                            }
                        });
                        if (_data[tableDataId]) {
                            _data[tableDataId].tableData = {
                                ..._data[tableDataId].tableData,
                                showDetailPanel: tableRef.current.props.detailPanel[0].render
                            }

                            setDataObjects(_data);
                        }
                    }
                }
            })
    }

    const tableHeight = `calc(100vh - ${88 + 74 + 56 + 52 + 0}px)`; // filter-bar + toolbar + col-header + pagination + padding

    const canAdd = UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']);

    const addNew = async () => {
        const config = OBJECT_TYPE_CONFIG[selected];
        if (!config) {
            return;
        }
        setIsLoading(true);
        try {
            const result = config.objecttype === 'realestateobject'
                ? await ObjecttypeService.getRealestateobjectTypeGuid(config.type, token, realm)
                : await ObjecttypeService.getAdministrativeobjectTypeGuid(config.type, token, realm);
            const typeGuid = result?.data?.guid;
            if (!typeGuid) {
                return;
            }
            setDataObjectSelected({ [config.objecttype + 'TypeGuid']: typeGuid });
            setDataobjectsDialogOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    const canAddSelected = canAdd && !!OBJECT_TYPE_CONFIG[selected];

    const FilterToolbar = useCallback(
        (props) => (
            <>
                <MTableToolbar {...props} />
                <div style={{ position: 'absolute', right: '415px', top: '14px', display: 'flex', gap: '20px' }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => addNew()}
                        disabled={!canAddSelected}
                    >
                        Objekt hinzufügen
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<FilterListIcon />}
                        onClick={() => setFiltering(f => !f)}
                    >
                        Spaltenfilter
                    </Button>
                </div>
            </>
        ),
        [setFiltering, canAddSelected, selected]
    );

    return (
        <>

        <div className="page-filter-bar" style={{ background: 'rgb(240, 244, 248)', padding:'8px 5px' }}>

                <ObjecttypeSelectlist
                    options={options}
                    selected={selected}
                    handleChange={handleChange}
                    label="Objekt wählen"
                    style={{ minWidth: 260 }}
                />

        </div>
        <div style={{ padding: '12px', boxSizing: 'border-box', width: '100%' }}>
        <MaterialTable
            tableRef={tableRef}
            title={title}
            columns={[
                { title: 'Bezeichnung', field: 'name' },
                { title: 'Nummer', field: 'number'},
                { title: 'Kennzeichen', field: 'label' },
                { title: 'Typ', field: getColumnType()},
                { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' }, hidden: hideDeactivatedColumn }
            ]}
            data={dataObjects}

            onRowClick={(event, rowData) => {
                    navigate(buildRealmPath(realm, '/Dataobject'), {state: {subObjects: rowData, title: rowData.name, objectType: selected}})
                }
            }
            options={{
                headerStyle: header,
                rowStyle: rowData => ({
                    backgroundColor: (rowData.deactivated) ? '#EEE' : '#FFF',
                    display: (hideDeactivatedColumn && rowData.deactivated) ? 'none': ''
                }),
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                actionsColumnIndex: -1,
                filtering,
                exportButton: true,
                exportAllData: true,
                maxBodyHeight: tableHeight,
                minBodyHeight: tableHeight,
            }}
            components={{
                Container: props => <Paper {...props} style={{ ...props.style, position: 'relative' }} />,
                Toolbar: FilterToolbar,
            }}
            actions={[
                {
                    icon: 'edit',
                    tooltip: 'Editieren',
                    onClick: (event, rowData) => handleEditClick(rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                },
                rowData => ({
                    icon:  rowData.deactivated ? 'taskalt' : 'cancel',
                    tooltip: rowData.deactivated ? 'Aktivieren': 'Deaktivieren',
                    onClick: rowData.deactivated ? (event, rowData) => handleActivateClick(rowData, event) :(event, rowData) => handleDeactivateClick(rowData, event),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }),
                bauteilAction,
                {
                    icon: 'upload',
                    tooltip: 'Upload',
                    onClick: (event, rowData) => handleUploadClick(event, rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }

            ]}
            isLoading={isLoading}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} von {count}',
                    labelRowsSelect: 'Zeilen',
                    labelRowsPerPage: 'Zeilen pro Seite'
                },
                toolbar: {
                    nRowsSelected: '{0} Zeile(n) ausgewählt',
                    searchTooltip: 'Suchen',
                    searchPlaceholder: 'Suchbegriff eingeben'
                },
                header: {
                    actions: 'Aktionen'
                },
                body: {
                    emptyDataSourceMessage: 'Keine Einträge gefunden',
                    filterRow: {
                        filterTooltip: 'Filter'
                    }
                }
            }}
        />
        </div>
            <DataObjectsEdit dataObjectSelected={dataObjectSelected}
                             handleDeactivateClick={handleDeactivateClick}
                             handleActivateClick={handleActivateClick}
                             reloadObjects={reloadObjects}
            />
            <DataComponentEdit
                dataObjectSelected={dataObjectSelected}
                setDataComponentEditDialogOpen={setDataComponentEditDialogOpen}
                DataComponentEditDialogOpen={DataComponentEditDialogOpen}
                handleUploadClick={handleUploadClick}
                setDataComponentFormDialogOpen={setDataComponentFormDialogOpen}
                DataComponentFormDialogOpen={DataComponentFormDialogOpen}
            />
            <UploadDialog
                dataObjectSelected={dataObjectSelected}
                setUploadDialogOpen={setUploadDialogOpen}
                uploadDialogOpen={uploadDialogOpen}
            />

        </>
    )
}

function DataobjectsList() {
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const classes = useSharedListStyles();

    const [dataObjects, setDataObjects] = useState([]);

    let navigate = useNavigate();

    useEffect(()=>{
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
            navigate(buildRealmPath(realm, '/'));
        }
    }, []);

    const handleObjecttypeChange = (objecttype, type) => {
        return trackPromise(
            GetObjectDataByType(objecttype, type, realm, token).then((bla) => {
                setDataObjects(bla.data);
            }));
    };

    return (
        <div>
            <div className={classes.katalogView}>
                <LoadingIndicator/>
                <div className={classes.btListe}>

                        <DataobjectsListTable
                            dataObjects={dataObjects}
                            realm={realm}
                            token={token}
                            setDataObjects={setDataObjects}
                            handleObjecttypeChange={handleObjecttypeChange}
                        />

                </div>

            </div>

        </div>
    );
}

export default DataobjectsList;
